export default __webpack_public_path__ + "static/media/_1208702-2.23d7cef1.webp";